<ngx-spinner
  name="upsSpinner"
  bdColor="rgba(255, 255, 255, 0.8)"
  size="medium"
  color="#321815"
  type="custom"
  [fullScreen]="true">
  <app-spinner></app-spinner>
</ngx-spinner>

@if (isLoading) {
  <div class="spinner-container">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}

<!-- Spinner and Dashboard Section -->
<div class="col-12">

  @if (!isLoader) {
    <div class="card card-body card-gbs-history">
      <span class="list-title">GBS History</span>

      <!-- Filters -->
      <div class="filter-container col-12">
        <form [formGroup]="dateForm" class="filter-form">

          <!-- Start Date -->
          <mat-form-field id="startDate" class="filter-field">
            <mat-label>Start Date</mat-label>
            <input
              class="fs-13"
              formControlName="startDate"
              matInput
              [matDatepicker]="startDatepicker"
              [errorStateMatcher]="matcher"
              placeholder="MM/DD/YYYY"
              name="startDate" />
              <mat-datepicker-toggle matSuffix [for]="startDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #startDatepicker></mat-datepicker>
              @if (dateForm.hasError('dateRangeInvalid')) {
                <mat-error class="start-date-error">
                  Start Date should be less than End Date.
                </mat-error>
              }
            </mat-form-field>

            <!-- End Date -->
            <mat-form-field id="endDate" class="filter-field">
              <mat-label>End Date</mat-label>
              <input
                class="fs-13"
                formControlName="endDate"
                matInput
                [matDatepicker]="endDatepicker"
                [errorStateMatcher]="matcher"
                placeholder="MM/DD/YYYY"
                name="endDate" />
                <mat-datepicker-toggle matSuffix [for]="endDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #endDatepicker></mat-datepicker>
                @if (dateForm.hasError('endDateRequired') && (dateForm.get('endDate')?.touched || dateForm.get('startDate')?.touched)) {
                  <mat-error
                    class="date-error">
                    End date is required when start date is provided.
                  </mat-error>
                }
                @if (dateForm.hasError('dateRangeInvalid')) {
                  <mat-error class="date-error">
                    End date must be after start date.
                  </mat-error>
                }
              </mat-form-field>

              <!-- Status Filter
              <mat-form-field id="statusFilter" class="filter-field">
                <mat-label>Status</mat-label>
                <mat-select formControlName="statusFilter" name="statusFilter">
                  <mat-option value="0">All</mat-option>
                  <mat-option value="6">✅ Completed</mat-option>
                  <mat-option value="7">📥 Received</mat-option>
                  <mat-option value="8">⏳ Waiting for Approval</mat-option>
                  <mat-option value="9">✏️ Sent to Corrections</mat-option>
                  <mat-option value="10">🕓 Pending Rebill</mat-option>
                  <mat-option value="11">❌ Rejected</mat-option>
                  <mat-option value="13">❓ GBS Need More Info</mat-option>
                </mat-select>
              </mat-form-field>-->

              <button type="button" id="btnApply" (click)="onSubmit()" class="btn btn-yellow-filled">
                <i class="fas fa-search"></i> Apply
              </button>
            </form>
          </div>

          <!-- Main Table -->
          <app-dynamictable
            [displayedColumns]="mainTableFieldMapping"
            [dataSource]="dataSource"
            [isFromGBS]="true"
            [useManualPaging]="true"
            [totalCount]="totalCount"
            [pageSize]="pageSize"
            [activeFilters]="currentAppliedFilters"
            (openDialog)="openAcceptOrRejectDialog($event)"
            (filterChange)="getAdjustmentDetails(1, 20, $event.filters, false)"
            (paginationChange)="getAdjustmentDetails($event.pageIndex + 1, $event.pageSize, [], $event.isRefresh || false)">
          </app-dynamictable>
        </div>
      }

      <ng-template #detailsTemplate>
        <div class="custom-modal-overlay">
          <div class="custom-modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Request Details</h4>
              <button
                type="button"
                class="btn btn-warning btn-lg close-btn"
                aria-label="Close"
                (click)="closeDetailsPopup()"
                [disabled]="isLoading">
                <i class="fas fa-window-close"></i>
              </button>
            </div>

            <!-- Top table (Main row) -->
            <div class="modal-body">
              <span class="section-heading">Main Request Info</span>
              <app-dynamictable
                [displayedColumns]="detailTableFieldMapping"
                [dataSource]="invoiceDataSource"
                [isFromGBS]="true"
                [useManualPaging]="false"
                [isSearchRequired]="false"
                [isFromBulkUpload]="true">
              </app-dynamictable>
            </div>

            <!-- Bottom table (Child details) -->
            <div class="modal-body">
              <span class="section-heading">Statement Details</span>
              <app-dynamictable
                [displayedColumns]="mainRequestInfo"
                [dataSource]="invoiceDataSource"
                [isFromGBS]="true"
                [useManualPaging]="false"
                [isSearchRequired]="false"
                [isFromBulkUpload]="true">
              </app-dynamictable>
            </div>
          </div>
        </div>
      </ng-template>



    </div>
